import $ from "jquery";

let Logout_Link;

Logout_Link = selector => {
    $(document).on("click", selector, function(e) {
        let logoutForm;
        let next;
        e.preventDefault();
        logoutForm = $("#logout-form");
        next = $(this).data("next");
        if (next) {
            logoutForm.attr(
                "action",
                `${logoutForm.attr("action")}?next=${next}`
            );
        }
        return logoutForm.trigger("submit");
    });
};

export default Logout_Link("#user-logout");
